import React, { useState } from 'react';
import { STag, SIcon } from '@avalara/skylab-sdk/react';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import { STATUS_ROW_TYPE } from '../../../utils/nlDigipoortV2Mock';

const TAG_COLOR_BY_TYPE = {
  [STATUS_ROW_TYPE.Success]: 'green-lighter',
  [STATUS_ROW_TYPE.Info]: 'blue-lighter',
  [STATUS_ROW_TYPE.Error]: 'red-lighter',
};

const TRUNCATE_AT = 80;

function ErrorDescriptionCell({ text }) {
  const [expanded, setExpanded] = useState(false);
  const isLong = text.length > TRUNCATE_AT;

  return (
    <span>
      {isLong && !expanded ? `${text.slice(0, TRUNCATE_AT)}…` : text}
      {isLong && (
        <a className="ml5" onClick={() => setExpanded((value) => !value)}>
          <LanguageStringResolver string={expanded ? 'submitFilingNLV2_Less' : 'submitFilingNLV2_More'} />
        </a>
      )}
    </span>
  );
}

function SubmissionStatusTable({ rows, onRefresh }) {
  return (
    <table className="updated-card-table" data-testid="nl-digipoort-v2-status-table">
      <thead>
        <tr>
          <th><LanguageStringResolver string="submitFilingNLV2_ColumnCode" /></th>
          <th><LanguageStringResolver string="submitFilingNLV2_ColumnDescription" /></th>
          <th><LanguageStringResolver string="submitFilingNLV2_ColumnTimestamp" /></th>
          <th><LanguageStringResolver string="submitFilingNLV2_ColumnErrorCode" /></th>
          <th><LanguageStringResolver string="submitFilingNLV2_ColumnErrorDescription" /></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            <td><STag color={TAG_COLOR_BY_TYPE[row.type]}><span slot="content">{row.code}</span></STag></td>
            <td>{row.description}</td>
            <td>{row.timestamp}</td>
            <td>{row.errorCode || '—'}</td>
            <td>{row.errorDescription ? <ErrorDescriptionCell text={row.errorDescription} /> : '—'}</td>
            <td>
              {onRefresh && (
                <a className="button" onClick={() => onRefresh(row)}>
                  <SIcon name="refresh" className="mr5" style={{ verticalAlign: 'middle' }} />
                  <LanguageStringResolver string="submitFilingNLV2_Refresh" />
                </a>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}


export default SubmissionStatusTable;
